// extracted by mini-css-extract-plugin
export default {"modal_dialog":"CustomKeyboard_modal_dialog__0yJhK","keyboard_modal":"CustomKeyboard_keyboard_modal__iNxy7"};